export default "__VITE_ASSET__27c3964f__"